import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";

import { isAuthenticated, signOut } from "helpers/zoomAuth";

const ENV_RESOURCE = process.env.REACT_APP_ENV_RESOURCE
const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  let email = localStorage.getItem("email_"+ENV_RESOURCE);
  const [username, setusername] = useState(email);
  const [isZoomAuthenticated, setZoomAuthenticated] = useState(false);

  useEffect(() => {
    console.log("Checking Zoom Authentication...");
    if (isAuthenticated()) {
      console.log("Zoom Authenticated.");
      setZoomAuthenticated(true);
    } else {
      console.log("Zoom Not Authenticated.");
      setZoomAuthenticated(false);
    }
  }, []);

  const handleZoomLogin = () => {
    window.location.href = `${process.env.REACT_APP_CAREX_ZOOM_SERVICE_ENDPOINT}/oauth`;
  };

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {isZoomAuthenticated ? (
            <DropdownItem onClick={() => signOut(setZoomAuthenticated)}>
              <i className="bx bx-video font-size-16 align-middle me-1 text-danger" />
              <span>{props.t("Zoom Logout")}</span>
            </DropdownItem>
          ) : (
            <DropdownItem onClick={handleZoomLogin}>
              <i className="bx bx-video font-size-16 align-middle me-1 text-success" />
              <span>{props.t("Zoom Login")}</span>
            </DropdownItem>
          )}
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span >{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
